import {
	AppBar,
	Box,
	Grid2,
	IconButton,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';
import TopBarDropdownMenu from './TopBarDropdownMenu';
import { useNavigate } from 'react-router-dom';
import Avatar from '../assets/images/Avatar.png';

interface TopNavigationBarProps {
	onClickLogo?: () => void;
	onClickLogout?: () => void;
	anchorEl: null | HTMLElement;
	open: boolean;
	handleClose: () => void;
	handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function TopNavigationBar(props: TopNavigationBarProps) {
	const theme = useTheme();
	const navigator = useNavigate();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	function onLogout() {
		localStorage.clear();
		navigator('/login', { replace: true });
	}

	return (
		<AppBar
			position="fixed"
			style={{ backgroundColor: '#f1f9f8' }}
			elevation={0}>
			<Grid2
				container
				style={{ paddingLeft: '7px', backgroundColor: '#FFFFFF' }}>
				{isMobile ? (
					<IconButton disableRipple onClick={props.onClickLogo}>
						<Typography
							fontSize={'18px'}
							fontWeight={'700'}
							color={MAIN_THEME_COLOR}>
							AskAI
						</Typography>
					</IconButton>
				) : (
					<Grid2
						container
						flexDirection={'row'}
						width={'100%'}
						alignItems={'center'}
						paddingLeft={'8px'}
						justifyContent={'space-between'}
						height={'50px'}>
						<IconButton disableRipple onClick={props.onClickLogo}>
							<Typography
								fontSize={'18px'}
								fontWeight={'700'}
								color={MAIN_THEME_COLOR}>
								AskAI
							</Typography>
						</IconButton>
						<Grid2
							container
							flexDirection={'row'}
							marginRight={'20px'}
							justifyContent={'flex-end'}
							alignItems={'center'}>
							<IconButton
								disableRipple
								sx={{ padding: '5px' }}
								onClick={props.handleClick}>
								<Box
									component={'img'}
									src={Avatar}
									width={36}
									height={36}
								/>
							</IconButton>
							<TopBarDropdownMenu
								anchorEl={props.anchorEl}
								open={props.open}
								handleClose={props.handleClose}
								onLogout={onLogout}
							/>
						</Grid2>
					</Grid2>
				)}
			</Grid2>
		</AppBar>
	);
}

export default TopNavigationBar;
